import { map, upperFirst } from 'lodash'

export const error = state => state.error
export const isLoading = state => state.isLoading
export const items = state => state.items
export const view = state => state.view
export const totalItems = state => state.totalItems

export const getThumbnails = state => {
  return map(state.items, (thumbnail) => {
    return { data: thumbnail, columns: createThumbnailColumn(thumbnail) }
  })
}

function createThumbnailColumn (thumbnail) {
  return [
    { field: 'image', value: thumbnail.path, type: 'image' },
    { field: 'type', value: upperFirst(thumbnail.type), type: 'string' }
  ]
}
